module.exports = __webpack_public_path__ + "static/media/Ringflip.964f2bd8.png";